module.exports = __webpack_public_path__ + "static/assets/7c3cee97eda772af1d4585b4c684bcc4.png";